'use strict';

const constants = require('./constants');
self.importScripts(constants.LODASH);
const MessageType = require('./worker/MessageType');
const workerLogger = require('./workerLogger');
const errors = require('./errors');
const workerUtils = require('./worker/workerUtils');
const bootstrapHandler = require('./worker/bootstrapHandler');
const loadHandler = require('./worker/loadHandler');
const initHandler = require('./worker/initHandler');
const startHandler = require('./worker/startHandler');
const renderHandler = require('./worker/renderHandler');
const loadUserCodeHandler = require('./worker/loadUserCodeHandler');
const UserCodeStore = require('./worker/UserCodeStore');
const AppsStore = require('./worker/AppsStore');

const _ = require('lodash');
const handleLoad = _.once(loadHandler.handleLoad);
const handleInit = _.once(initHandler.handleInit);
const handleStart = _.once(startHandler.handleStart);
const handleRendered = _.once(renderHandler.handle);
const updateWixCodeDataAfterLogin = loadHandler.updateWixCodeDataAfterLogin;

const devConsole = workerLogger.wrapConsole(console, self.postMessage);
const userCodeStore = new UserCodeStore();
const appsStore = new AppsStore();
let workerId = null;

self.onerror = function onError(message, filename, lineno, colno, err) {
  devConsole.error(err ? err : message);
  workerUtils.reportBI(errors.PLATFORM_LIFECYCLE_UNHANDLED_EXCEPTION, {
    errorMsg: message,
    stack: err && err.stack,
    line: lineno,
    column: colno
  });
};

self.onmessage = function onMessage(message) {
  if (!message.data) {
    return;
  }
  switch (message.data.type) {
    case MessageType.BOOTSTRAP:
      bootstrapHandler.handleBootstrap(message.data, {appsStore});
      break;
    case MessageType.LOAD_USER_CODE:
      loadUserCodeHandler.handleLoadUserCode(message.data, {userCodeStore});
      break;
    case MessageType.LOAD:
      workerId = message.data.workerId;
      handleLoad(message.data, {
        workerId,
        getApp: appsStore.get.bind(appsStore),
        userCodeStore
      });
      break;
    case MessageType.INIT:
      handleInit(message.data, {
        workerId,
        getApp: appsStore.get.bind(appsStore)
      });
      break;
    case MessageType.START:
      handleStart(message.data, {
        workerId,
        getAllApps: appsStore.getAll.bind(appsStore)
      });
      break;
    case MessageType.PAGE_RENDERED:
      handleRendered(message.data);
      break;
    case MessageType.UPDATE_WIX_CODE_DATA_AFTER_LOGIN:
      updateWixCodeDataAfterLogin(message.data);
      break;
    default:
      delegateMessageToSDK(message);
      break;
  }
};

function delegateMessageToSDK(message) {
  if (self.wix) {
    self.wix.__INTERNAL__.onMessage(message);
  }
}



// WEBPACK FOOTER //
// ./src/main/worker.js